import { Api } from 'api';
import { ApplicationUser } from 'api/interfaces/applicationUser';
import { CRUDResponse } from 'api/interfaces/CRUDResponse';
import { Dispatch } from 'redux';
import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { preparePayload } from 'redux/actions/users/common';
import { ApplicationState } from 'redux/applicationState';
import { UsersActions } from 'redux/reducers/usersReducer';

export const updateUser = (user: ApplicationUser) => {
  return (
    dispatch: Dispatch<Action<UsersActions>>,
    getState: () => ApplicationState,
    api: Api
  ): VoidFunction => {
    const state = getState();
    const payload = preparePayload(state.usersForm, user);

    const task = api.updateUser(payload);

    dispatch(createAction(UsersActions.updateUserStarted));
    const run = async (): Promise<CRUDResponse> => {
      const result = await task.run();
      const update = api.getUsers();

      await new Promise<void>((resolve: () => void): void => {
        setTimeout((): void => {
          update.run().then(resolve);
        }, 500);
      });

      return result;
    };

    run()
      .then((result: CRUDResponse): void => {
        if (result.success) {
          dispatch(createAction(UsersActions.updateUserCompleted, result));
        } else {
          dispatch(createAction(UsersActions.updateUserFailed, result.message));
        }
      })
      .catch((error: Error): void => {
        dispatch(createAction(UsersActions.updateUserFailed, error.message));
      });

    return (): void => {
      task.cancel();
    };
  };
};
